import { render, staticRenderFns } from "./LayoutGroup.vue?vue&type=template&id=0dcd9f99&"
import script from "./LayoutGroup.vue?vue&type=script&lang=js&"
export * from "./LayoutGroup.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGroup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports